import * as React from "react";
import {useState} from "react";
import {useMutation} from "@apollo/react-hooks";
import {Button, Modal} from "semantic-ui-react";

import {REQUEST_ANNOTATION_REVIEW_MUTATION, RequestAnnotationReviewResponse, RequestAnnotationReviewVariables
} from "../../graphql/reconstruction";
import {CompleteReconstructionPanel} from "./CompleteReconstructionPanel";

export type CompleteReconstructionDialogProps = {
    id: string;
    show: boolean;
    onClose(): void;
}

export const CompleteReconstructionDialog = (props: CompleteReconstructionDialogProps) => {
    const [state, setState] = useState({
        duration: "",
        length: "",
        notes: "",
        checks: "",
    })

    const [completeReconstruction, {data: completeData}] = useMutation<RequestAnnotationReviewResponse, RequestAnnotationReviewVariables>(REQUEST_ANNOTATION_REVIEW_MUTATION,
        {
            refetchQueries: ["ReconstructionsQuery"]
        });

    const updateDuration = (value: string) => setState({...state, duration: value});
    const updateLength = (value: string) => setState({...state, length: value});
    const updateNotes = (value: string) => setState({...state, notes: value});
    const updateChecks = (value: string) => setState({...state, checks: value});

    const canMarkAsComplete = (state.duration.trim().length == 0 || !isNaN(parseFloat(state.duration))) &&
        (state.length.trim().length == 0 || !isNaN(parseFloat(state.length)));

    const markAsComplete = async () => {
        const duration = state.duration.trim().length == 0 ? 0 : parseFloat(state.duration);
        const length = state.length.trim().length == 0 ? 0 : parseFloat(state.length);

        await completeReconstruction({variables: {id: props.id, duration: duration, length: length, notes: state.notes, checks: state.checks}});

        props.onClose();
    }

    return (
        <Modal closeIcon centered={false} open={props.show} onClose={props.onClose} dimmer="blurring">
            <Modal.Header content={`Mark Reconstruction for Review`}/>
            <Modal.Content>
                <CompleteReconstructionPanel id={props.id} data={state} updateDuration={updateDuration} updateLength={updateLength} updateNotes={updateNotes} updateChecks={updateChecks}/>
            </Modal.Content>
            <Modal.Actions>
                <Button color="blue" content="Request Review" disabled={!canMarkAsComplete} onClick={markAsComplete}/>
                <Button content="Cancel" onClick={props.onClose}/>
            </Modal.Actions>
        </Modal>
    );
}
